import React from "react";

// Carousel
import { Carousel } from "react-responsive-carousel";

// useStyles
import useStyles from "./styles";

// Material-UI
// import { IconButton } from "@material-ui/core";

// Icons
// import { NavigateBefore, NavigateNext } from "@material-ui/icons";

function ImageCarousel({ thumbnails }) {
  const classes = useStyles();

  return (
    <Carousel
      className={classes.carousel}
      emulateTouch={true}
      infiniteLoop={true}
      showStatus={false}
      showIndicators={false}
      showThumbs={false}
      onClickItem={(_, item) => {
        window.open(item?.props?.src)
      }}
      autoPlay={false}
    >
      {thumbnails.map((item, index) => {
        return (
          <img
            key={index}
            src={item.thumbnail}
            alt={item.key}
            style={{
              objectFit: "contain",
              width: 360,
              height: 360,
              margin: "0 auto",
            }}
          />
        );
      })}
    </Carousel>
  );
}

export default ImageCarousel;
